import React from "react";
import { PlanDetailsSection } from "../@types";

interface PlanDetailListProps {
  title: string;
  titleChildren?: React.ReactNode;
  id: PlanDetailsSection;
}

const PlanDetailList: React.FunctionComponent<PlanDetailListProps> = ({
  children,
  title,
  titleChildren,
  id,
}) => {
  return (
    <div>
      <h2 className="PlanDetailList__header" id={id} tabIndex={-1}>
        {title}
        {titleChildren}
      </h2>
      <div className="PlanDetailList__list">{children}</div>
    </div>
  );
};

export default PlanDetailList;
